import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventEmitterService } from 'src/app/core/services/event-emitter.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { SwalService } from 'src/app/core/services/swal.service';

@Component({
  selector: 'app-historique-savoir-faire',
  templateUrl: './historique-savoir-faire.component.html',
  styleUrls: ['./historique-savoir-faire.component.css']
})
export class HistoriqueSavoirFaireComponent implements OnInit {
  @Input() COMPETITIVITE: any
  @Input() MAITRISE_POSTE: any
  @Input() QSSE: any
  @Input() RESULTATS: any
  public note_maitrise_poste: any = 0;
  public resultat_maitrise_poste: any = 0;
  public note_qsse: any = 0;
  public resultat_qsse: any = 0;
  public resultat_competitivite: any = 0;
  public nbre_rubrique_evaluee_qsse: any = 0;
  public nbre_rubrique_evaluee_maitrise_poste: any = 0;
  public nbre_rubrique_evaluee_competitivite: any = 0;
  public nbre_rubrique_evaluee_global: any = 0;
  public note_competitivite: any = 0;
  public appreciation_maitrise_poste: any = 'Aucune appréciation';
  public appreciation_qsse: any = 'Aucune appréciation';
  public appreciation_competitivite: any = 'Aucune appréciation';
  public note_global: any;
  public resultat_global: any;
  public appreciation_global: any;
  public listMaitrisePoste: any = [];
  public arrayNotationsMaitrisePoste: any = [];
  public loaderText: any;
  public arrayNotationsQsse: any = [];
  public listQsse: any = [];
  public arrayNotationsCompetitivite: any = [];
  public listCompetitivite: any = [];
  public qsse_radio: any;
  public tab: any = [];
  public typeVisualisation: any;
  public typeFiche: any;
  public entretien_id: any;
  public agent_id: any;
  public vueActive: any;
  public statut: any;
  public typeSauvegarde: any;
  public clickEventsubscription: Subscription;

  constructor() { }

  getListeMaitrisePoste() {

    this.listMaitrisePoste = this.MAITRISE_POSTE?.sous_rubriques;

    // this.checkSums(this.listMaitrisePoste);

    this.nbre_rubrique_evaluee_maitrise_poste = this.listMaitrisePoste?.length
    this.resultat_maitrise_poste = this.RESULTATS?.maitrise_poste?.resultat_maitrise_poste;
    this.appreciation_maitrise_poste = this.RESULTATS?.maitrise_poste?.appreciation_maitrise_poste;

    let notationsRubriqueUn = [];
    let notationsRubriqueDeux = [];
    let notationsRubriqueTrois = [];
    let notationsRubriqueQuatre = [];
    let notationsRubriqueCinq = [];
    /**
     * @param notationsRubriqueUn correspond a la première rubrique de la section maitrise du poste
     * @param notationsRubriqueDeux correspond a la deuxième rubrique de la section maitrise du poste
     * @param notationsRubriqueTrois correspond a la troisième rubrique de la section maitrise du poste
     * @param notationsRubriqueQuatre correspond a la quatrième rubrique de la section maitrise du poste
     * @param notationsRubriqueCinq correspond a la cinquième rubrique de la section maitrise du poste
     */
    for (let index = 0; index <= this.listMaitrisePoste?.length; index++) {
      notationsRubriqueUn = this.listMaitrisePoste[0].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueUn.forEach(element => {
      this.arrayNotationsMaitrisePoste.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listMaitrisePoste?.length; index++) {
      notationsRubriqueDeux = this.listMaitrisePoste[1].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueDeux.forEach(element => {
      this.arrayNotationsMaitrisePoste.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listMaitrisePoste?.length; index++) {
      notationsRubriqueTrois = this.listMaitrisePoste[2].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueTrois.forEach(element => {
      this.arrayNotationsMaitrisePoste.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listMaitrisePoste?.length; index++) {
      notationsRubriqueQuatre = this.listMaitrisePoste[3].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueQuatre.forEach(element => {
      this.arrayNotationsMaitrisePoste.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listMaitrisePoste?.length; index++) {
      notationsRubriqueCinq = this.listMaitrisePoste[4].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueCinq.forEach(element => {
      this.arrayNotationsMaitrisePoste.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
  }

  getListeQsse() {

    this.listQsse = this.QSSE?.sous_rubriques;

    // this.checkSums(this.listQsse);

    this.resultat_qsse = this.RESULTATS?.qsse?.resultat_qsse;
    this.appreciation_qsse = this.RESULTATS?.qsse?.appreciation_qsse;
    this.nbre_rubrique_evaluee_qsse = this.listQsse?.length;

    let notationsRubriqueUn = [];
    let notationsRubriqueDeux = [];
    let notationsRubriqueTrois = [];
    let notationsRubriqueQuatre = [];
    let notationsRubriqueCinq = [];
    /**
     * @param notationsRubriqueUn correspond a la première rubrique de la section maitrise du poste
     * @param notationsRubriqueDeux correspond a la deuxième rubrique de la section maitrise du poste
     * @param notationsRubriqueTrois correspond a la troisième rubrique de la section maitrise du poste
     * @param notationsRubriqueQuatre correspond a la quatrième rubrique de la section maitrise du poste
     * @param notationsRubriqueCinq correspond a la cinquième rubrique de la section maitrise du poste
     */
    for (let index = 0; index <= this.listQsse?.length; index++) {
      notationsRubriqueUn = this.listQsse[0].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueUn.forEach(element => {
      this.arrayNotationsQsse.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listQsse?.length; index++) {
      notationsRubriqueDeux = this.listQsse[1].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueDeux.forEach(element => {
      this.arrayNotationsQsse.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listQsse?.length; index++) {
      notationsRubriqueTrois = this.listQsse[2].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueTrois.forEach(element => {
      this.arrayNotationsQsse.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listQsse?.length; index++) {
      notationsRubriqueQuatre = this.listQsse[3].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueQuatre.forEach(element => {
      this.arrayNotationsQsse.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listQsse?.length; index++) {
      notationsRubriqueCinq = this.listQsse[4].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueCinq.forEach(element => {
      this.arrayNotationsQsse.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
  }

  getListeCompetitivite() {
    this.listCompetitivite = this.COMPETITIVITE?.sous_rubriques;


    this.resultat_competitivite = this.RESULTATS?.competitivite?.resultat_competitivite;
    this.appreciation_competitivite = this.RESULTATS?.competitivite?.appreciation_competitivite;
    this.nbre_rubrique_evaluee_competitivite = this.listCompetitivite?.length;

    let notationsRubriqueUn = [];
    let notationsRubriqueDeux = [];
    let notationsRubriqueTrois = [];
    /**
     * @param notationsRubriqueUn correspond a la première rubrique de la section maitrise du poste
     * @param notationsRubriqueDeux correspond a la deuxième rubrique de la section maitrise du poste
     * @param notationsRubriqueTrois correspond a la troisième rubrique de la section maitrise du poste
     */
    for (let index = 0; index <= this.listCompetitivite?.length; index++) {
      notationsRubriqueUn = this.listCompetitivite[0].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueUn.forEach(element => {
      this.arrayNotationsCompetitivite.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listCompetitivite?.length; index++) {
      notationsRubriqueDeux = this.listCompetitivite[1].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueDeux.forEach(element => {
      this.arrayNotationsCompetitivite.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listCompetitivite?.length; index++) {
      notationsRubriqueTrois = this.listCompetitivite[2].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueTrois.forEach(element => {
      this.arrayNotationsCompetitivite.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
  }

  public checkSums(data) {
    let totalSums
    let barems = [] as any
    let newArray = []
    for (const value of data) {
      for (const row of value.notations) {
        if (row.ischecked) {
          newArray.push(row);
        }
      }
    }

    newArray.forEach((element) => {
      barems.push(element.barem)
    });


    totalSums = barems.reduce(
      (acc, item) => acc + parseInt(item.valeur),
      0
    );

    return totalSums
  }

  ngOnInit() {
    /* Get URL details */
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];

    /* Get All Maitrise poste */
    this.getListeMaitrisePoste();

    /* Get All Qsse */
    this.getListeQsse();

    /* Get All Competitivite*/
    this.getListeCompetitivite();

    this.resultat_global = this.RESULTATS?.synthese_savoir_faire_tt?.note
    this.nbre_rubrique_evaluee_global = this.RESULTATS?.synthese_savoir_faire_tt?.nbre
    this.appreciation_global = this.RESULTATS?.savoir_faire?.appreciation_savoir_faire
  }


  containsObjectArrayMaitrisePoste(id_rubrique) {
    let i;
    for (i = 0; i < this.arrayNotationsMaitrisePoste?.length; i++) {
      if (this.arrayNotationsMaitrisePoste[i].rubrique_id === id_rubrique) {
        return true;
      }
    }
    return false;
  }

  containsObjectArrayQsse(id_rubrique) {
    let i;
    for (i = 0; i < this.arrayNotationsQsse?.length; i++) {
      if (this.arrayNotationsQsse[i].rubrique_id === id_rubrique) {
        return true;
      }
    }
    return false;
  }

  containsObjectArrayCompetitivite(id_rubrique) {
    let i;
    for (i = 0; i < this.arrayNotationsCompetitivite?.length; i++) {
      if (this.arrayNotationsCompetitivite[i].rubrique_id === id_rubrique) {
        return true;
      }
    }
    return false;
  }

  isCheckedMaitrisePoste(rubrique_id, notations_id) {
    const is_exist = this.containsObjectArrayMaitrisePoste(rubrique_id);
    if (!is_exist) {
      this.arrayNotationsMaitrisePoste.push({
        'rubrique_id': rubrique_id,
        'id': notations_id,
      });
    } else {
      const new_array = this.arrayNotationsMaitrisePoste.filter(
        (element) => element.rubrique_id !== rubrique_id
      );
      this.arrayNotationsMaitrisePoste = new_array;
      this.arrayNotationsMaitrisePoste.push({
        'id': notations_id,
        'rubrique_id': rubrique_id
      });
    }
    return this.arrayNotationsMaitrisePoste;
  }

  isCheckedQsse(rubrique_id, notations_id) {
    const is_exist = this.containsObjectArrayQsse(rubrique_id);
    if (!is_exist) {
      this.arrayNotationsQsse.push({
        'rubrique_id': rubrique_id,
        'id': notations_id,
      });
      this.nbre_rubrique_evaluee_qsse++;
    } else {
      const new_array = this.arrayNotationsQsse.filter(
        (element) => element.rubrique_id !== rubrique_id
      );
      this.arrayNotationsQsse = new_array;
      this.arrayNotationsQsse.push({
        'id': notations_id,
        'rubrique_id': rubrique_id
      });
    }
    return this.arrayNotationsQsse;
  }

  isCheckedCompetitivite(rubrique_id, notations_id) {
    const is_exist = this.containsObjectArrayCompetitivite(rubrique_id);
    if (!is_exist) {
      this.arrayNotationsCompetitivite.push({
        'rubrique_id': rubrique_id,
        'id': notations_id,
      });
    } else {
      const new_array = this.arrayNotationsCompetitivite.filter(
        (element) => element.rubrique_id !== rubrique_id
      );
      this.arrayNotationsCompetitivite = new_array;
      this.arrayNotationsCompetitivite.push({
        'id': notations_id,
        'rubrique_id': rubrique_id
      });
    }
    return this.arrayNotationsCompetitivite;
  }


}
